// src/components/matchInput/StarterStep.js
import React, { useEffect } from "react";
import SelectBox from "../../central/SelectBox";

const leagueConfig = {
  "5-a-side": {
    maxStarters: 5,
  },
  "7-a-side": {
    maxStarters: 7,
  },
  "9-a-side": {
    maxStarters: 9,
  },
  "11-a-side": {
    maxStarters: 11,
  },
  // Add other league types and their configs here as needed
};

/**
 * Expects:
 *  - appearanceData: { [playerId]: { appeared: boolean, isGK: boolean } }
 *  - starterData:    { [playerId]: true }   (checkbox style)
 */
export default function StarterStep({
  players = [],
  appearanceData = {},
  starterData = {},
  setStarterData,
  leagueType = "7-a-side",
  onNext,
}) {
  let numericLeagueType = 7;
  if (typeof leagueType === "string") {
    const match = leagueType.match(/\d+/);
    if (match) numericLeagueType = parseInt(match[0], 10);
  } else {
    numericLeagueType = leagueType;
  }

  // Only players who appeared can be starters
  const appearedPlayers = players.filter(
    (p) => appearanceData?.[p.id]?.appeared === true
  );

  const toggleStarter = (playerId) => {
    setStarterData((prev) => {
      const isCurrentlySelected = !!prev?.[playerId];
      // Count how many starters are currently selected (true)
      const selectedCount = Object.values(prev || {}).filter(Boolean).length;
      if (!isCurrentlySelected && selectedCount >= maxStarters) {
        // Trying to select more than allowed
        console.log(
          `⛔️ Cannot select more than ${maxStarters} starters.`
        );
        // Optionally show alert for debugging
        // alert(`Cannot select more than ${maxStarters} starters.`);
        return prev;
      }
      // Allow toggle (deselecting always allowed, selecting only if under limit)
      return {
        ...prev,
        [playerId]: !isCurrentlySelected,
      };
    });
  };

  const resolvedLeagueType = `${numericLeagueType}-a-side`;
  const maxStarters = leagueConfig[resolvedLeagueType]?.maxStarters || 5;
  console.log("🏆 LeagueType received:", leagueType);

  // Auto-fill starters on first load: select the first N appeared players (top-down)
  useEffect(() => {
    const selectedCount = Object.values(starterData || {}).filter(Boolean).length;
    if (selectedCount > 0) return; // don't overwrite user selections
    if (!appearedPlayers || appearedPlayers.length === 0) return;

    const autoSelected = {};
    appearedPlayers.slice(0, maxStarters).forEach((p) => {
      autoSelected[p.id] = true;
    });

    setStarterData(autoSelected);
  }, [appearedPlayers, maxStarters, starterData, setStarterData]);

  return (
    <div style={{ width: "100%", textAlign: "left" }}>
      {maxStarters !== undefined && (
        <p style={{ fontStyle: "italic", fontSize: "0.9em", marginBottom: 8, textAlign: "left" }}>
          <strong>Tap a player</strong> to mark them as a starter
          <br/>
          Max starters for {resolvedLeagueType.replace(/-/g, " ")} league: {maxStarters}
        </p>
      )}

      {appearedPlayers.length === 0 ? (
        <p style={{ color: "red" }}>No players marked as appearing yet.</p>
      ) : (
        <ul style={{ listStyle: "none", paddingLeft: 0, marginLeft: 0 }}>
          {appearedPlayers.map((p) => {
            return (
              <SelectBox
                key={p.id}
                selected={!!starterData?.[p.id]}
                onClick={() => toggleStarter(p.id)}
              >
                {p.name} ({p.position}) {appearanceData?.[p.id]?.isGK ? "🧤" : ""}
              </SelectBox>
            );
          })}
        </ul>
      )}
    </div>
  );
}